import type { RouteObject } from 'react-router-dom';

/**
 * View 12, the queue of envios under review. It depends on D11, so the route is
 * built and tested but the destination does not enter the menu (see
 * `nav/envios.nav.ts`).
 */
export const enviosRoutes: RouteObject[] = [
  {
    path: 'envios',
    lazy: () =>
      import('@/routes/pages/EnviosReviewPage').then((m) => ({
        Component: m.EnviosReviewPage,
      })),
  },
];
